import samsungWallet from 'assets/images/wallet/samsung-wallet.png';
import React from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  Linking,
  StyleSheet,
  TouchableHighlight,
  View,
  ViewProps,
} from 'react-native';

function SamsungViewWalletButton({ style }: ViewProps) {
  return (
    <View style={style} testID="SamsungWalletButton">
      <TouchableHighlight
        style={style}
        onPress={openSamsungPay}
        underlayColor="white"
      >
        <ImageBackground
          source={samsungWallet as ImageSourcePropType}
          resizeMode="contain"
          style={styles.samsungWalletButtonImage}
        />
      </TouchableHighlight>
    </View>
  );
}

const styles = StyleSheet.create({
  samsungWalletButtonImage: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    minHeight: 48,
  },
});

const openSamsungPay = async () => {
  const samsungPayUrl = 'com.samsung.android.spay'; // Samsung Pay package name
  await openWallet(samsungPayUrl);
};

const openWallet = async (url: string) => {
  try {
    const supported = await Linking.canOpenURL(`market://details?id=${url}`);
    if (supported) {
      await Linking.openURL(`market://details?id=${url}`);
    }
  } catch {
    //TODO JT-125740 add errors
  }
};

export default SamsungViewWalletButton;
